var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "relative flex justify-center w-full py-6 lg:px-6 bg-slate-200",
      attrs: { id: "action-recommendation" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full border bg-pure-white rounded-3xl border-slate-400"
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center justify-between p-6 lg:p-10",
              attrs: { id: "recommendation-header" }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-col gap-1" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "hidden p-2 bg-orange-300 lg:block",
                          style: { borderRadius: "4px" }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-6 h-6",
                            attrs: { icon: "tooltip" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextTitle4", {
                        attrs: { text: "Action recommendations" }
                      }),
                      _vm._v(" "),
                      _c("BlBubbleCount", {
                        attrs: { count: _vm.totalActionRecommendations || 0 }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Below are the targets that have successfully reached their success metrics and may need further action."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedRecommendation.length
                ? _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label:
                            "Ignore (" +
                            _vm.selectedRecommendation.length +
                            ")",
                          loading: _vm.submitLoading
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onIgnore(_vm.selectedRecommendation)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label:
                            "Update (" +
                            _vm.selectedRecommendation.length +
                            ")",
                          loading: _vm.submitLoading
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.onAccept(_vm.selectedRecommendation)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "px-10 py-5",
              attrs: { id: "recommendation-metric" }
            },
            [
              _vm.pageLoading
                ? _c("div", { staticClass: "grid place-items-center h-92" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : !_vm.actionRecommendations.length
                ? _c(
                    "div",
                    { staticClass: "grid place-items-center h-92" },
                    [
                      _c("BlTextBody1", {
                        staticClass: "text-center lg:w-128 text-grey-400",
                        attrs: {
                          text:
                            "Currently, there are no targets that have yet passed the success metric."
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "relative pb-4 overflow-x-auto scrollbar-lg"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex text-grey",
                          attrs: { id: "metric-header" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "sticky left-0 z-10 flex items-start flex-shrink-0 gap-2 px-3 py-2 border-r rounded-l bg-slate-200 w-72 border-slate-400"
                            },
                            [
                              _c("BlInputCheck", {
                                staticClass: "mt-1",
                                attrs: {
                                  checked: _vm.masterChecked,
                                  indeterminate: _vm.masterIndeterminate
                                },
                                on: { changed: _vm.onChangeSelectedAll }
                              }),
                              _vm._v(" "),
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Target" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Curriculum" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Method" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Latest session by" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Success metric" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Total successful sessions" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 w-48 px-3 py-2 bg-slate-200"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Number of consecutive success" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-shrink-0 px-3 py-2 rounded-r bg-slate-200 w-104"
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Recommended action" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.actionRecommendations, function(
                        recommendation
                      ) {
                        return _c(
                          "div",
                          { key: recommendation.id, staticClass: "flex h-18" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sticky left-0 z-10 flex items-center flex-shrink-0 gap-2 px-3 py-4 border-b border-r w-72 border-slate-400 bg-pure-white",
                                attrs: { title: recommendation.target.name }
                              },
                              [
                                _c("BlInputCheck", {
                                  attrs: {
                                    checked: _vm.selectedRecommendation.includes(
                                      recommendation.id
                                    )
                                  },
                                  on: {
                                    changed: function($event) {
                                      return _vm.onChangeSelected(
                                        recommendation.id
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey",
                                  attrs: { text: recommendation.target.name }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 gap-2 px-3 py-4 border-b border-slate-400",
                                attrs: {
                                  title: recommendation.target.curriculum_name
                                }
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "flex-shrink-0 w-4 h-4 rounded-full",
                                  style: {
                                    background:
                                      recommendation.target.curriculum_color
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey-400",
                                  attrs: {
                                    text: recommendation.target.curriculum_name
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-slate-400",
                                attrs: {
                                  title: recommendation.target.type_name
                                }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey-400",
                                  attrs: {
                                    text: recommendation.target.type_name
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-slate-400"
                              },
                              [
                                !recommendation.latest_session_by
                                  ? _c("BlTextBody1", {
                                      staticClass:
                                        "italic truncate text-grey-400",
                                      attrs: {
                                        title: "Deleted user",
                                        text: "Deleted user"
                                      }
                                    })
                                  : _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          event: _vm.currentUser.role.includes(
                                            "admin"
                                          )
                                            ? "click"
                                            : "",
                                          target: "_blank",
                                          to: {
                                            name: "TeamSessionHistory",
                                            params: {
                                              user_id:
                                                recommendation.latest_session_by
                                                  .id,
                                              redirect_target:
                                                "/clients/" + _vm.id,
                                              redirect_label:
                                                "Client recommendations"
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center justify-center h-8 px-3 truncate border rounded bg-success-100 border-success-100 max-w-40",
                                            class: [
                                              _vm.currentUser.role.includes(
                                                "admin"
                                              )
                                                ? "hover:border-success-400"
                                                : "cursor-default"
                                            ],
                                            attrs: {
                                              title:
                                                recommendation.latest_session_by
                                                  .name
                                            }
                                          },
                                          [
                                            _c("BlTextBody1", {
                                              staticClass:
                                                "truncate text-success",
                                              attrs: {
                                                text:
                                                  recommendation
                                                    .latest_session_by.name
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-slate-400",
                                attrs: {
                                  title: _vm.generateSuccessMetric(
                                    recommendation.target
                                  )
                                }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey-400",
                                  attrs: {
                                    text: _vm.generateSuccessMetric(
                                      recommendation.target
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-slate-400"
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey-400",
                                  attrs: {
                                    text: recommendation.target.total_success
                                      ? recommendation.target.total_success +
                                        " session(s)"
                                      : "-"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center flex-shrink-0 w-48 px-3 py-4 border-b border-slate-400"
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "truncate text-grey-400",
                                  attrs: {
                                    text: recommendation.target
                                      .consecutive_success
                                      ? recommendation.target
                                          .consecutive_success + " time(s)"
                                      : "-"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-between flex-shrink-0 gap-4 px-3 py-4 border-b w-104 border-slate-400"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-2" },
                                  [
                                    _c("StatusChip", {
                                      attrs: {
                                        status: recommendation.target.status
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-grey-300" },
                                      [_vm._v("→")]
                                    ),
                                    _vm._v(" "),
                                    _c("StatusChip", {
                                      attrs: {
                                        status:
                                          recommendation.recommended_action
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.selectedRecommendation.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2"
                                      },
                                      [
                                        _c("BlInputButton", {
                                          attrs: {
                                            type: "outlined",
                                            label: "Ignore",
                                            loading: _vm.submitLoading
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.onIgnore([
                                                recommendation.id
                                              ])
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlInputButton", {
                                          attrs: {
                                            label: "Update",
                                            loading: _vm.submitLoading
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.onAccept([
                                                recommendation.id
                                              ])
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
            ]
          ),
          _vm._v(" "),
          _vm.totalActionRecommendations > 10
            ? _c("BlInputPagination", {
                staticClass: "my-6",
                attrs: {
                  count: Math.ceil(
                    _vm.totalActionRecommendations /
                      (_vm.$route.query["per_page"] || 10)
                  ),
                  page: _vm.page
                },
                on: { changed: _vm.changePage }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b66aae8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b66aae8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientRecommendation.vue
// module id = null
// module chunks = 